import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@scentregroup/ui'
import ExternalLink from '../../external-link'
import style from './index.module.scss'

const GetDirections = props => {
  const className = props.className
  const latitude = props.latitude
  const longitude = props.longitude
  const url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`

  return (
    <div className={className}>
      <ExternalLink url={url} className={style.directionLink}>
        Get directions
      </ExternalLink>
      <span className={style.directionArrow}>
        <Icon size="small" type="chevron-right" />
      </span>
    </div>
  )
}

GetDirections.propTypes = {
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  className: PropTypes.string,
}

export default GetDirections
